import React from "react";
import BackButtom from "../../../components/backButton";
import {
  RegraTributariaRequest,
  RegraTributariaResponse,
} from "../../../../domain/models/regra-tributaria";
import RegraModal from "./regra-modal";
import * as S from "./styles";

type Props = {
  regras: RegraTributariaResponse[];
  loading: boolean;
  // Modal
  modalVisible: boolean;
  editingRegra: RegraTributariaResponse | null;
  saving: boolean;
  onOpenModal: (regra?: RegraTributariaResponse) => void;
  onCloseModal: () => void;
  onSave: (data: RegraTributariaRequest) => void;
  // Ações
  onToggleAtivo: (id: number) => void;
  onDelete: (id: number) => void;
  togglingId: number | null;
};

const RegrasTributariasPage: React.FC<Props> = ({
  regras,
  loading,
  modalVisible,
  editingRegra,
  saving,
  onOpenModal,
  onCloseModal,
  onSave,
  onToggleAtivo,
  onDelete,
  togglingId,
}) => {
  const formatCondicao = (condicao: RegraTributariaResponse["condicao"]): JSX.Element => {
    let parsed = condicao;
    if (typeof condicao === "string") {
      try { parsed = JSON.parse(condicao); } catch { parsed = []; }
    }
    if (!parsed || !Array.isArray(parsed) || parsed.length === 0) {
      return <S.ConditionBadge>Padrão (sem condição)</S.ConditionBadge>;
    }
    return (
      <>
        {parsed.map((c, i) => (
          <S.ConditionBadge key={i}>
            {c.key}={c.value}
          </S.ConditionBadge>
        ))}
      </>
    );
  };

  return (
    <S.Wrapper>
      <BackButtom text="Regras Tributárias" />
      <S.InfoBox>
        Gerencia as regras de classificação tributária para NFS-e Nacional.
        Cada regra define CST, cClassTrib e cIndOp com base em condições específicas (ex: tomador estrangeiro, natureza da operação).
        A prioridade determina qual regra é aplicada quando múltiplas condições são atendidas.
      </S.InfoBox>

      <S.HeaderRow>
        <span />
        <S.AddButton onClick={() => onOpenModal()}>+ Nova regra</S.AddButton>
      </S.HeaderRow>

      <S.SectionCard>
        {loading && (
          <S.LoadingText>Carregando regras...</S.LoadingText>
        )}
        {!loading && regras.length === 0 && (
          <S.LoadingText>Nenhuma regra tributária cadastrada.</S.LoadingText>
        )}
        {!loading && regras.length > 0 && (
          <S.Table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Prioridade</th>
                <th>Condição</th>
                <th>CST</th>
                <th>cClassTrib</th>
                <th>cIndOp</th>
                <th>Ativo</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {regras.map((regra) => (
                <tr key={regra.id}>
                  <td>{regra.nome}</td>
                  <td>{regra.prioridade}</td>
                  <td>{formatCondicao(regra.condicao)}</td>
                  <td><code>{regra.cst}</code></td>
                  <td><code>{regra.cclasstrib}</code></td>
                  <td><code>{regra.cindop}</code></td>
                  <td>
                    <S.ToggleSwitch>
                      <input
                        type="checkbox"
                        checked={regra.ativo}
                        disabled={togglingId === regra.id}
                        onChange={() => onToggleAtivo(regra.id)}
                      />
                      <span />
                    </S.ToggleSwitch>
                  </td>
                  <td>
                    <S.ActionButton
                      $variant="edit"
                      onClick={() => onOpenModal(regra)}
                    >
                      Editar
                    </S.ActionButton>
                    <S.ActionButton
                      $variant="delete"
                      onClick={() => onDelete(regra.id)}
                    >
                      Excluir
                    </S.ActionButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </S.Table>
        )}
      </S.SectionCard>

      <RegraModal
        visible={modalVisible}
        regra={editingRegra}
        saving={saving}
        onClose={onCloseModal}
        onSave={onSave}
      />
    </S.Wrapper>
  );
};

export default RegrasTributariasPage;
